import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const goBookOrDashboard = () => {
    setIsMobileMenuOpen(false);
    if (user) navigate('/dashboard');
    else navigate('/signup', { state: { from: '/dashboard' } });
  };

  return (
    <header className={`header-nav ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <div className="logo-wrapper">
            <span className="logo-text">SOUL ALIGNED</span>
          </div>

          {/* Desktop Navigation */}
          <nav className="nav-links desktop-nav">
            <button onClick={() => scrollToSection('services')} className="nav-link">Services</button>
            <button onClick={() => scrollToSection('about')} className="nav-link">About</button>
            <button onClick={() => scrollToSection('testimonials')} className="nav-link">Testimonials</button>
            <button onClick={() => scrollToSection('faq')} className="nav-link">FAQ</button>
          </nav>

          <div className="nav-actions">
            {user ? (
              <Link to="/dashboard" className="btn-primary" data-testid="header-dashboard-btn">
                My Dashboard
              </Link>
            ) : (
              <>
                <button
                  onClick={() => navigate('/login')}
                  className="btn-ghost"
                  data-testid="header-login-btn"
                >
                  Sign in
                </button>
                <button
                  onClick={goBookOrDashboard}
                  className="btn-primary"
                  data-testid="header-book-session-btn"
                >
                  Book Session
                </button>
              </>
            )}

            <button
              className="mobile-menu-toggle"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="mobile-nav">
            <button onClick={() => scrollToSection('services')} className="mobile-nav-link">Services</button>
            <button onClick={() => scrollToSection('about')} className="mobile-nav-link">About</button>
            <button onClick={() => scrollToSection('testimonials')} className="mobile-nav-link">Testimonials</button>
            <button onClick={() => scrollToSection('faq')} className="mobile-nav-link">FAQ</button>
            {!user && (
              <button
                onClick={() => { setIsMobileMenuOpen(false); navigate('/login'); }}
                className="mobile-nav-link"
                data-testid="mobile-login-btn"
              >
                Sign in
              </button>
            )}
            <button
              onClick={goBookOrDashboard}
              className="btn-primary mobile-cta"
              data-testid="mobile-book-session-btn"
            >
              {user ? 'My Dashboard' : 'Book Session'}
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
